import { useGoodsRoute } from '../../../hooks/useGoodsRoute';

export const useGoodsSno = () => {
  const { params } = useGoodsRoute<'GoodsDetail'>();

  return params.goodsId;
};
